import React, { useState, useEffect } from "react";
import Church from "./../../assets/explore04.webp";
import Resident from "./../../assets/resident.webp";
import School from "./../../assets/Montfort_school-1-yercaud-salem-India.webp";

const ImageGrid = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    {
      id: 1,
      src: School,
      text: "Educational Institutions",
      subtext: "Constructing schools, sports courts, and cultural auditoriums.",
    },
    {
      id: 2,
      src: Church,
      text: "Worship Space Architecture",
      subtext: "Constructed church buildings with interior & exterior elevations.",
    },
    {
      id: 3,
      src: Resident,
      text: "Residential & Commercial Projects",
      subtext: "Modern housing solutions, office spaces, and retail complexes.",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        display: "grid",
        gap: "10px",
        rowGap: isSmallScreen ? "10px" : "40px",// ✅ Increased vertical spacing between rows
        marginTop: isSmallScreen ? "10px" : "-20px",
        padding: "0px 0px 50px 0px",
        overflow: "hidden",

        /* ✅ Large Screens */
        gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
        gridTemplateRows: isSmallScreen ? "auto" : "50% 30%",
        gridTemplateAreas: isSmallScreen
          ? `"image1"
             "image2"
             "image3"`
          : `"image1 image1"
             "image2 image3"`,
      }}
    >
      {images.map((image, index) => (
        <div
          key={image.id}
          style={{
            position: "relative",
            overflow: "hidden",
            height: isSmallScreen ? "auto" : index === 0 ? "500px" : "400px", // ✅ Reduced height
            gridArea: index === 0 ? "image1" : index === 1 ? "image2" : "image3",
          }}
        >
          {/* Image */}
          <img
            src={image.src}
            alt={image.text}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "grayscale(100%)",
              transition: "opacity 0.4s ease",
            }}
          />


          {/* Text Overlay */}
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              color: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              padding: "10px",
              transition: "background-color 0.4s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#5c0e14"; // 🔥 On hover: Red background
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
            }}
          >
            {image.text}
            <p style={{ fontSize: "14px", fontWeight: "normal", marginTop: "5px", padding:"20px" }}>{image.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
